import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconTestimonials = ({ id, color, width = 14, style, ...restProps }: IProps) => {
  const viewBoxWidth = 14;
  const viewBoxHeight = 12;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M12.713 0C13.423 0 14 .611 14 1.363v7.64c0 .752-.576 1.363-1.285 1.363-.315 0-.784.236-.985.495l-.527.681c-.225.291-.546.458-.88.458-.334 0-.655-.167-.88-.458l-.528-.681c-.2-.26-.67-.495-.987-.495H1.287C.577 10.366 0 9.755 0 9.003v-7.64C0 .61.577 0 1.287 0h11.426zm.36 9.003v-7.64c0-.21-.161-.382-.36-.382H1.287c-.199 0-.36.171-.36.382v7.64c0 .21.161.382.36.382h6.641c.595 0 1.327.367 1.704.854l.527.681c.098.128.229.128.327 0l.528-.681c.376-.487 1.108-.854 1.701-.854.198 0 .359-.171.359-.382zm-2.961-5.778c.256 0 .463.22.463.49 0 .271-.207.491-.463.491H3.757a.477.477 0 0 1-.463-.49c0-.271.207-.49.463-.49h6.355zM7.635 5.748c.256 0 .463.22.463.49s-.207.49-.463.49H3.757a.477.477 0 0 1-.463-.49c0-.27.207-.49.463-.49h3.878z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconTestimonials;
